import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DetectorStateI } from '../types/app';
import { selectedDetectorI } from '../types/detectors';

const getInitialDetectorsState = (): selectedDetectorI => ({
    detector: {
        tech: '',
        id: undefined,
        type: '',
        name: '',
        refImg: '',
        icon: '',
        state: '',
        x: undefined,
        y: undefined,
        connectedActuatorIds: []
    }
});

const initialState: selectedDetectorI = getInitialDetectorsState();

const detectorsSlice = createSlice({
    name: 'detectors',
    initialState,
    reducers: {
        setSelectedDetector: (state, action: PayloadAction<DetectorStateI>) => {
            state.detector = action.payload;
        }
    }
});

export const {
    setSelectedDetector
} = detectorsSlice.actions;
export default detectorsSlice.reducer;
